<template>
  <b-modal id="change-date">
    <template #modal-header="{ close }">
      <h5>Sửa ngày hoàn thành phiếu</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div class="text-center">
      <datepicker placeholder="Chọn ngày" format="dd/MM/yyyy" v-model="dateReport"></datepicker>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="primary" @click="updateDateComplete"> Lưu </b-button>
      <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
    </template>
  </b-modal>
</template>

<script>
  import moment from 'moment'
  export default {
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        dateReport: null,
      }
    },
    methods: {
      async updateDateComplete() {
        const data = this.formattedTimestamp(this.dateReport)
        if (this.dateReport) {
          this.$emit('updateDateComplete', data)
        } else this.showFailMx('Chọn ngày muốn sửa!')
      },
      onHidden() {
        this.$emit('onHidden')
      },
      formattedTimestamp(date) {
        const momentObject = moment(date, 'ddd MMM DD YYYY HH:mm:ss [GMT]Z')

        const timestamp = momentObject.valueOf()

        return timestamp
      },
    },
  }
</script>

<style scoped></style>
